import Axios from './helpers/api_client';

export function getAPI(endPoint) {
  return Axios.get(
    process.env.REACT_APP_API_HRMS_BASE_URL + endPoint,
    null,
  ).then((res) => {
    if (res.status !== 200) throw res.data.message;
    return res.data;
  });
}

export function postAPI(formData, endPoint) {
  return Axios.post(
    process.env.REACT_APP_API_HRMS_BASE_URL + endPoint,
    formData,
  ).then((res) => {
    if (res.status !== 200) {
      throw res.data.message;
    }
    return res.data;
  });
}

export function downloadAPI(endPoint) {
  return Axios(process.env.REACT_APP_API_HRMS_BASE_URL + endPoint, {
    responseType: 'blob',
    method: 'GET',
  }).then((res) => {
    if (res.status !== 200) {
      throw res.data;
    }
    return res.data;
  });
}

export function getAPIWithFilters(filters = {}, endPoint) {
  let query = '?';
  for (var f in filters) {
    if (filters[f]) {
      query += f + '=' + filters[f] + '&';
    }
  }
  return Axios.get(
    `${process.env.REACT_APP_API_HRMS_BASE_URL}${endPoint}${query}`,
  ).then((res) => {
    if (res.status !== 200) throw res.data.message;
    return res.data;
  });
}
